<h1 mat-dialog-title>
  New Project ID
</h1>
<div mat-dialog-content class="dense-1">
  <div class="row gx-0">
    <p>Updating a project ID can cause significant issues if there is an existing project already with the same ID.</p>
    <p>The update will apply to all related data and tables for the project (staff, expenses, work assignment, user permissions).</p>
  </div>
  <div class="row gx-0 pb-2">
    Current ID: {{ currentId }}
  </div>
  <div class="row gx-0 mx-4">
    <mat-form-field>
      <mat-label>New ID</mat-label>
      <input matInput type="text" [(ngModel)]="newId" (keyup)="checkId()">
    </mat-form-field>
  </div>
  @if (error) {
    <div class="row gx-0 text-danger fw-bold">
      <p>This project ID is already in use, be certain this is what you want to do!</p>
      <p>This will transfer project settings, staff, work, and expenses into the existing project. It will not transfer tasks or permissions. Upload the project (with the new ID) to update these.</p>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="close()">Close</button>
  <button matButton="filled" [mat-dialog-close]="newId" class="mat-ctrlkey-orange" [disabled]="newId === undefined || !newId">Submit</button>
</div>